import { a, getDisplayedShapes, getMode, selectIfMouseInShapeBoundary } from "../../shared/globalState/a";
import { g } from "../../shared/globalState/g";
import { s } from "../../shared/globalState/settings";

import { addShapes, deleteOneShape, updateActiveShapes, updateAndDrawShapes } from "../../shared/render/shapes";
import {
  canvasGetMouse,
  findRectangleAndLineIntersectionPoints,
  getSideOfMouseRelativeToLine,
  isHorizontal,
  pointInsideRectangle
} from "../../shared/common";

import { magnet$ } from "../../libs/canvas-text/src/shared/state";

// --- rxjs

import { Point } from "../../models/Point";
import { CommandList as cl } from "../../models/CommandList";
import {
  handleAssignConnectionPoints,
  handleCircle,
  handleCopyMousedown,
  handleEditMousedown,
  handleLine,
  handleMirrorMousedown,
  handleMoveMousedown,
  handleMoveRoutePartMousedown,
  handleRectangle,
  handleRotateAndCopyMousedown,
  handleRotateMousedown,
  handleScaleMousedown,
  handleSquare
} from "../../services/operations.ts";
import { handleSpacebarDown } from "../keyboard/spacebar";
import { clearTooltipAll } from "../../services/tooltip.ts";
import { observeJoins } from "../../services/joinObserver.ts";
import { setLastTouchedSegment } from "../../shared/globalState/a";


function handleSelect() {
  a.selectFrame.start = a.start;
  a.selectFrame.end = null;
}

function handleSymLine() {
  a.symline.start = a.start;
}

/**
 * @desc Функция выполняется при нажатии мыши. В зависимости от режима, который узнаётся через функцию gm(), выполняются разные блоки
 * @property {Point} a.start - Переменная назначается однажды, в самом начале функции и используется
 * как начальная точка. В зависимости от того, назначена ли точка a.magnetPosition, может быть или равна
 * текущему положению мыши, или точке a.magnetPosition
 * @property {Point} a.magnetPosition - Переменная назначается только в одном месте всей программы
 * через наблюдатель magnetState$ в функции handleMouseMove.
 *
 *
 *
 */


function handleMouseDown(event) {

  if (event.button === 1 || event.button === 4) {
    handleSpacebarDown();
    return;
  }


  // если UI заблокирован, то возврат - ничего не создаётся и не выбирается
  if (a.blockUI || a.pan) return;

  var mouse = canvasGetMouse(event, g.canvas);

  a.isMouseDown = true;

  if (a.magnetPosition) {
    a.start = a.magnetPosition.clone();
  } else {
    a.start = mouse.clone();
  }

  // --- text
  magnet$.next(a.start);
  // --- text

  setLastTouchedSegment(
    observeJoins(mouse, a.activeShapes)
  );


  switch (getMode()) {
    case "none":
      break;

    case cl.cm.break.type: {
      let filteredShapes = getDisplayedShapes().filter(shape => shape.isinSelectBoundary(mouse));

      // выбрана 1 линия
      if (filteredShapes.length === 1) {
        let shape = filteredShapes[0];
        switch (shape.type) {
          case cl.cm.line.type: {
            const { bs, be } = shape.getBreakPoints(mouse, a.shapes);

            if (!bs) {
              return;
            } else if ((bs && !be) || (bs?.x === be.x && bs?.y === be.y)) {
              const side = getSideOfMouseRelativeToLine(mouse, bs, shape);
              if (side === "start") {
                shape.start = bs;
              } else if (side === "end") {
                shape.end = bs;
              }

            } else {
              const side = getSideOfMouseRelativeToLine(mouse, bs, shape);
              const line1 = shape.getClone();
              const line2 = shape.getClone();
              if (side === "start") {
                line1.end = be;
                line2.start = bs;
              } else if (side === "end") {
                line1.start = be;
                line2.end = bs;
              }
              

              addShapes(line1);
              addShapes(line2);
              a.shapes = a.shapes.filter(s => s.id !== shape.id);
              updateActiveShapes();
            }
            break;
          }
          case cl.cm.rectangle.type: {
            // удаляем прямоугольник
            deleteOneShape(shape);
            // разбиваем прямоугольник на линии
            let linesFromRectangle = shape.getLines();

            let linesID = [];
            linesFromRectangle.forEach(line => {
              addShapes(line);
              linesID.push(line.id);
            });


            let rectangles = a.shapes.filter(s => s.type === cl.cm.rectangle.type);
            let intersections = [];
            let intersectedLines = [];
            rectangles.forEach(r => {
              if (pointInsideRectangle(mouse, r.p1, r.p2, r.p3, r.p4)) {
                linesFromRectangle.forEach(l => {
                  if (findRectangleAndLineIntersectionPoints(r.p1, r.p2, r.p3, r.p4, l.start, l.end).length > 0) {
                    intersections.push(findRectangleAndLineIntersectionPoints(r.p1, r.p2, r.p3, r.p4, l.start, l.end));
                    intersectedLines.push(l);
                  }
                });
              }
            });
            intersections = intersections.filter(i => i.length > 0);

            intersections.forEach((int, index) => {
              let bs = int[0];
              let be = int[1];
              let line = intersectedLines[index];
              if (int.length == 1) {
                let side = getSideOfMouseRelativeToLine(mouse, bs, line);

                if (side === "start") {
                  line.start = bs;
                } else if (side === "end") {
                  line.end = bs;
                }

                // TODO: удалить линию, которая остаётся

              } else if (int.length == 2) { // 2 точки
                const side = getSideOfMouseRelativeToLine(mouse, bs, line);
                const line1 = line.getClone();
                const line2 = line.getClone();
                if (side === "start") {
                  line1.end = be;
                  line2.start = bs;
                } else if (side === "end") {
                  line1.start = be;
                  line2.end = bs;
                }


                addShapes(line1);
                addShapes(line2);

                a.shapes = a.shapes.filter(s => s.id !== line.id);


              }

            });


            // обновляем активные фигуры, так как количество фигур изменилось. Массив activeShapes используется в подписчиках магнитов и областей фигур в файле move.js
            updateActiveShapes();
            break;
          }
          default:
            break;
        }


      }
      // выбрано 2 пересекающихся линии
      else if (filteredShapes.length === 2) {
        const [l1, l2] = filteredShapes;
        const horizontalLine = isHorizontal(l1, l2);
        const breakPoints = horizontalLine.getBreakPoints(mouse, filteredShapes);
        const line1 = horizontalLine.getClone();
        line1.end = new Point(breakPoints.bs.x - s.tolerance, line1.start.y);
        const line2 = horizontalLine.getClone();
        line2.start = new Point(breakPoints.bs.x + s.tolerance, line2.end.y);
        addShapes(line1);
        addShapes(line2);
        a.shapes = a.shapes.filter(s => s.id !== horizontalLine.id);
        updateActiveShapes();


      }
      break;
    }

    case cl.cm.select.type:
      handleSelect();

      break;
    case "boundary":
      selectIfMouseInShapeBoundary(mouse);


      break;
    case cl.cm.line.type:

      handleLine(mouse, a.start);
      a.gman.detectRoutes(true);
      clearTooltipAll();

      break;
    case cl.cm.symline.type:
      handleSymLine();
      break;
    case cl.cm.rectangle.type:
      handleRectangle(mouse);
      break;
    case cl.cm.square.type:
      handleSquare(mouse);
      break;
    case cl.cm.circle.type:
      handleCircle();
      break;
    case cl.cm.move.type:
      handleMoveMousedown(mouse);
      break;
    case cl.cm.copy.type:
      handleCopyMousedown(mouse);
      break;
    case cl.cm.rotate.type:
      handleRotateMousedown(mouse);
      break;
    case cl.cm.rotateCopy.type:
      handleRotateAndCopyMousedown(mouse);
      break;
    case cl.cm.mirror.type:
      handleMirrorMousedown(mouse);
      break;
    case cl.cm.scale.type:
      handleScaleMousedown(mouse);
      break;
    case "edit":
      handleEditMousedown(mouse);
      break;
    case cl.cm.moveRoutePart.type:

      handleMoveRoutePartMousedown();
      break;
    case cl.types.networkHeating:
      cl.cm.networkHeating.run(event);
      break;
    case cl.types.assignConnectionPoints:
      handleAssignConnectionPoints(mouse);
      break;
    default:
      break;
  }
  updateAndDrawShapes();
}

export { handleMouseDown };
